import React from "react";
import { useAtom } from "jotai/index";
import * as icon from "~/Icons";
import { volumeAtom } from "~/Atom";
import { PlaySound } from "~/SoundUtils";
import "~/css/Slider.css";

// デフォルト値の定数
const DEFAULT_DISABLED = false;
const SOUND_TYPE = "push2";

/**
 * スライダー操作用コントローラーコンポーネント
 * プラスとマイナスボタンでスライダー値を調整する
 */
interface SliderControllerProps {
  handleMinusValue: () => void;
  handlePlusValue: () => void;
  disabled?: boolean;
}

const SliderController: React.FC<SliderControllerProps> = ({
  handleMinusValue,
  handlePlusValue,
  disabled = DEFAULT_DISABLED,
}) => {
  const [volume] = useAtom(volumeAtom);
  /**
   * 操作音を再生する
   */
  const playControlSound = (): void => {
    PlaySound(SOUND_TYPE, volume);
  };

  return (
    <div className="slider-controls">
      <button
        className="slider-button left"
        onClick={handleMinusValue}
        onMouseUp={playControlSound}
        disabled={disabled}
      >
        <icon.icons_minus />
      </button>
      <button
        className="slider-button right"
        onClick={handlePlusValue}
        onMouseUp={playControlSound}
        disabled={disabled}
      >
        <icon.icons_plus />
      </button>
    </div>
  );
};

export default SliderController;
